import { init as initDDLogs } from '@sympla/datadog-logger/lib/client';
import { isServer } from '../misc';

export const initialConfig = {
  clientToken: `${process?.env?.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN}`,
  site: 'datadoghq.com',
  forwardErrorsToLogs: false,
  sampleRate: 100,
  service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
  version: '0.0.0',
  env: `${process?.env?.NODE_ENV}`,
};

export function browserLogger(config = initialConfig) {
  function init() {
    if (!isServer()) return initDDLogs(config);
    throw new Error('This should be called only on Browser');
  }

  const requestId = '';

  function error(payload: LogParams, locationError?: string) {
    const enhancedPayload = { ...payload, message: `[${requestId}][${locationError || ''}]${payload.message}` };
    if (!isServer()) return window.LOGS?.error(enhancedPayload);
    throw new Error('This should be called only on Browser');
  }

  function warn(payload: LogParams, locationError?: string) {
    const enhancedPayload = { ...payload, message: `[${requestId}][${locationError || ''}]${payload.message}` };
    if (!isServer()) return window.LOGS?.warn(enhancedPayload);
    throw new Error('This should be called only on Browser');
  }

  function info(payload: LogParams, locationError?: string) {
    const enhancedPayload = { ...payload, message: `[${requestId}][${locationError || ''}]${payload.message}` };
    if (!isServer()) return window.LOGS?.info(enhancedPayload);
    throw new Error('This should be called only on Browser');
  }

  return {
    init,
    error,
    warn,
    info,
  };
}
